import type React from 'react'

import { getLogoutUrl } from '@/client/services/url'

import ShwLink, { type ShwLinkProps } from '@/components/ShwLink'

type LogoutLinkProps = Omit<ShwLinkProps, 'href'>

export default function LogoutLink({ onClick, ...props }: LogoutLinkProps): React.ReactElement {
  return <ShwLink href={getLogoutUrl()} onClick={onClick} {...props} />
}
